import type { FreightMatching } from "@x-mile/api-contract";

// パレット, ケース, 紙帯, フレコン, 荷物そのまま, カゴ台車, コンテナ, ドラム缶, 番重, その他]
export const PACKING_STYLES_LIST: {
  value: NonNullable<FreightMatching.schemas.OfferCargoCollectionRequestBodyPackingStyle>;
  label: string;
}[] = [
  { value: "pallet", label: "パレット" },
  { value: "case", label: "ケース" },
  { value: "paper_band", label: "紙帯" },
  { value: "freight_conveyor", label: "フレコン" },
  { value: "none_package", label: "荷物そのまま" },
  { value: "roll_box_pallet", label: "カゴ台車" },
  { value: "container", label: "コンテナ" },
  { value: "drum", label: "ドラム缶" },
  { value: "plastic_container", label: "番重" },
  { value: "other", label: "その他" },
];
export const isPackagingStyle = (
  value: unknown,
): value is NonNullable<FreightMatching.schemas.OfferCargoCollectionRequestBodyPackingStyle> =>
  PACKING_STYLES_LIST.some((style) => style.value === value);

export const DEADLINE_TYPES_LIST: {
  value: NonNullable<FreightMatching.schemas.OfferDestinationDeadlineType>;
  label: string;
}[] = [
  { value: "till", label: "までに" },
  { value: "after", label: "以降" },
  { value: "just", label: "ちょうど" },
  { value: "earliest", label: "最短" },
  { value: "term", label: "時間帯指定" },
];

export const TASK_DETAILS_LIST: {
  value: NonNullable<FreightMatching.schemas.OfferDestinationTaskDetail>;
  label: string;
}[] = [
  { value: "forklift_use_owner", label: "フォークリフト(自主荷役あり)" },
  { value: "forklift_use_driver", label: "フォークリフト(自主荷役なし)" },
  { value: "handlift", label: "ハンドリフト" },
  { value: "unloading", label: "バラ" },
  { value: "crane", label: "クレーン" },
  { value: "other", label: "その他" },
];

export const OFFER_CARGO_VEHICLE_SHAPES_LIST: {
  value: NonNullable<FreightMatching.schemas.OfferCargoVehicleShape>;
  label: string;
}[] = [
  { value: "other", label: "指定なし" },
  { value: "flat", label: "平ボディ" },
  { value: "box", label: "箱車" },
  { value: "hood", label: "幌車" },
  { value: "dump", label: "ダンプ" },
  { value: "semi_trailer", label: "セミトレーラー" },
  { value: "full_trailer", label: "フルトレーラー" },
  { value: "wing", label: "ウィング" },
  { value: "unic", label: "ユニック" },
  { value: "refrigerator", label: "冷蔵車" },
  { value: "freezer", label: "冷凍車" },
];
export const isOfferCargoVehicleShape = (
  value: string | null | undefined,
): value is NonNullable<FreightMatching.schemas.OfferCargoVehicleShape> =>
  OFFER_CARGO_VEHICLE_SHAPES_LIST.some((shape) => shape.value === value);

// TODO: offer cargoの定数定義とvehicleの定数定義を分離する
export const VEHICLE_WEIGHT_CLASSES = [
  { value: 1, label: "1t" },
  { value: 2, label: "2t" },
  { value: 4, label: "4t" },
  { value: 10, label: "10t" },
  { value: 13, label: "13t" },
  { value: 20, label: "20t" },
];
export const isVehicleWeightClass = (
  value: number | null | undefined,
): value is 1 | 2 | 4 | 10 | 13 | 20 =>
  VEHICLE_WEIGHT_CLASSES.some((shape) => shape.value === value);

// TODO: offer cargoの定数定義とvehicleの定数定義を分離する
export const VEHICLE_SIZES: {
  value: "normal" | "short" | "long" | "wide";
  label: string;
}[] = [
  { value: "normal", label: "標準" },
  { value: "short", label: "ショート" },
  { value: "long", label: "ロング" },
  { value: "wide", label: "ワイド" },
] as const;
